module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"gl-monitoring-form wh100\">\n	<div class=\"table wh100 table-w-100-0\">\n		<div>\n			<div>\n				<div class=\"table table-100-0 wh100\">\n					<div>\n						<div name=\"map\" class=\"gl-map\"></div>\n					</div>\n					<div>\n						<div name=\"item-info\" class=\"gl-monitoring__item_info_container\"></div>\n					</div>\n				</div>\n			</div>\n			<div name=\"items\" class=\"h100 gl-monitoring__items\">\n				<div class=\"cell__abs_container\">\n					<div class=\"cell__abs\">\n						<div class=\"table wh100 table-0-100\">\n							<div>\n								<div name=\"filter\">\n								</div>\n							</div>\n							<div>\n								<div>\n									<div class=\"cell__abs_container\">\n										<div class=\"cell__abs overflow-y__auto\">\n											<div name=\"items-list\" class=\"table w100 gl-monitoring__items_table\"></div>\n										</div>\n									</div>\n								</div>\n							</div>\n						</div>\n					</div>\n				</div>\n			</div>\n		</div>\n	</div>\n</div>")
  }
  return __output.join("");

}